import { SET_CURRENCIES } from '@Actions/currencies';
export const defaultState = {
    currenciesList: []
};
export function currenciesReducer(state = defaultState, action) {
    switch (action.type) {
        case SET_CURRENCIES: {
            return Object.assign(Object.assign({}, state), { currenciesList: action.payload });
        }
        default:
            return state;
    }
}
